<template>
  <v-card class="content-card" elevation="1">
    <v-card-title class="card-title d-flex align-center">
      <span class="flex-grow-1">{{ title }}</span>
      <v-btn 
        color="primary" 
        @click="$emit('save')" 
        class="save-btn"
      >儲存模板</v-btn>
    </v-card-title>
    <v-card-text>
      <v-textarea
        ref="editorTextarea"
        :value="value"
        @input="$emit('input', $event)"
        solo
        label="請在此輸入內容"
        class="editor-textarea"
        rows="8"
        auto-grow
      ></v-textarea>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'SectionEditor',
  props: {
    title: {
      type: String,
      required: true,
    },
    value: {
      type: String,
      required: true,
    },
  },
};
</script>

<style scoped>
.content-card {
  border-radius: 10px;
  background-color: #ffffff;
  border: 1px solid #eef1f6;
  box-shadow: 0 1px 3px rgba(18, 38, 63, 0.06);
}

.card-title {
  font-size: 1.08rem;
  font-weight: 600;
  color: #2f3542;
  padding: 14px 16px 6px;
}

.v-card__text {
  padding: 8px 16px 16px;
  color: #4a4f57;
  line-height: 1.6;
}

.editor-textarea.v-textarea .v-input__control {
  background-color: #fff;
}

.editor-textarea >>> .v-input__slot {
  border-radius: 10px;
  border: 1px solid #e6e9ef;
}

.save-btn {
  width: 100px !important;
  min-width: 100px !important;
  max-width: 100px !important;
  flex-shrink: 0 !important;
  flex-grow: 0 !important;
}
</style>
